import React from 'react';
import { withStyles, FormControl, InputLabel, Select, Input } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: '90%',
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  margin: {
    margin: theme.spacing.unit,
  },
  cssLabel: {
    '&$cssFocused': {
      color: '#0098DA',
    },
  },
  cssFocused: {},
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#0098DA',
    },
  },
});

export default withStyles(styles)(props => {
  const { classes } = props;

  return (
    <FormControl className={classes.formControl} disabled={props.disabled || props.options.length === 0}>
      <InputLabel
        {...props.InputLabelProps}
        FormLabelClasses={{
          root: classes.cssLabel,
          focused: classes.cssFocused,
        }}
        htmlFor={props.id}
      >
        {props.label}
      </InputLabel>
      <Select
        native
        value={props.value}
        onChange={props.onChange}
        input={
          <Input
            classes={{ underline: classes.cssUnderline, }}
            id={props.id}
            autoComplete={'off'}
            onFocus={props.onFocus}
            onKeyUp={props.onKeyUp}
            onClick={props.onClick}
            onBlur={props.onBlur}
            type={props.type}
          />
        }
      >
        <option value="" />
        {props.options.map((option, index) => {
          return <option value={option.value} key={index}>{option.title}</option>;
        })}
      </Select>
    </FormControl>
  );
});
